// src/pages/EstudianteDashboard.jsx
import React from "react";
import FeedPublicaciones from "../components/rector/FeedPublicaciones"; 

export default function DashboardProfesor({ token }) {
  const API = process.env.REACT_APP_API || "http://3.236.217.225:5001/api";
  const SOCKET_URL = process.env.REACT_APP_SOCKET || "http://3.236.217.225:5001";

  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">Bienvenido profesor</h2>
      <FeedPublicaciones token={token} API={API} SOCKET_URL={SOCKET_URL} />
    </div>
  );
}
